import axiosInstance from './axiosInstance';

export const getAllFaqs = () => axiosInstance.get('/Faq/GetAll');
export const getFaqById = (id) => axiosInstance.get(`/Faq/GetById/${id}`);
export const createFaq = (data) => axiosInstance.post('/Faq/Create', data);
export const updateFaq = (data) => axiosInstance.put('/Faq/Update', data);
export const deleteFaq = (id) => axiosInstance.delete(`/Faq/Delete/${id}`);
export const uploadFaqImage = (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axiosInstance.post('/Faq/UploadImage', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};
